export const TARGET_CLIENT_IDs: number[] = []; // 빈 배열 == 모든 클라이언트

export const UNAUTHORIZED_SALES_CLIENT_IDS = [
  1330, 1563, 543, 1485, 1404, 1570, 614, 1395, 834, 1475, 1147, 1044, 618, 201,
];

export const EXCLUDED_CLIENT_IDS_FOR_HOME_BANNER: number[] = UNAUTHORIZED_SALES_CLIENT_IDS;

// https://marqvision.atlassian.net/browse/PROD-12529
export const TARGET_TICKET_NUMBER = 12529;
